var pathToRegExp = require('path-to-regexp')

/**
 * Expose `pathToRegexp` as ES6 module
 */
module.exports = pathToRegExp;
module.exports.parse = pathToRegExp.parse
module.exports.compile = pathToRegExp.compile
module.exports.tokensToFunction = pathToRegExp.tokensToFunction
module.exports.tokensToRegExp = pathToRegExp.tokensToRegExp
module.exports['default'] = module.exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/path-to-regexp-es6/index.js
// module id = 31
// module chunks = 5